/* eslint-disable prettier/prettier */
/* logo size = 60mm => 60/210= 28.57% of page width. Page width equals 595.35 pt. ==>> logo width = 595.35*0.2857 
   margin-right = 595.35 - 538.6 = 56.75
*/
const logo = {
    image: 'logo_oevbs_blau.png',
    width: 170,
    margin: [0, 31.7, 28.5, 0],
    alignment: 'right'
}

export { logo }